/**
 * Modo demo: se activa con `npm run dev:demo` (mode=demo) o con ?demo=1 en la URL.
 * Genera el libro sintético EN EL NAVEGADOR y construye el MISMO Snapshot que envía el servidor,
 * así el dashboard se ve igual sin llamar a Google. Se importa bajo demanda.
 */
import type { Snapshot } from '@redmil/shared';

export function isDemoRequested(): boolean {
  if (import.meta.env.MODE === 'demo') return true;
  return new URLSearchParams(location.search).get('demo') === '1';
}

export async function loadDemoSnapshot(seed = 20261013): Promise<Snapshot> {
  const { createDemoStore, todaySerial, buildSnapshot, SNAPSHOT_RANGES, KPI_ROWS, KPI_FORMULAS } = await import('@redmil/shared');
  const today = todaySerial();
  const store = createDemoStore({ seed, today });
  const values = SNAPSHOT_RANGES.map((r) => store.workbook.read(r));
  return buildSnapshot(
    { takenAt: Date.now(), values },
    { timeZone: 'America/Tegucigalpa', dashboardFormulas: KPI_ROWS.map((k) => KPI_FORMULAS[k.id]) },
    { canViewCosts: true, today },
  );
}
